import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IPackingNote } from "mobx-stores/_models/packing-note/packing-note";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NumberText } from "share-components/atomics/number-text";
import {
  DetailIconButton,
  ExpandButton,
} from "share-components/mui-wrap/button/action-button";
import { XGroupCell } from "share-components/mui-wrap/table/x-group-cell";
import { XSubRow } from "share-components/mui-wrap/table/x-sub-row";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const PackingNoteTable = observer(() => {
  const {
    packingNoteManagement: {
      packingNotes,
      getPackingNotes,
      pagination,
      searchConditionAsNaturalLanguage,
    },
  } = useStores();
  useEffect(() => {
    getPackingNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getPackingNotes();
    },
    [getPackingNotes, pagination],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageIndex + 1,
        onChange: onPageChanged,
      }}
      searchConditionAsNaturalLanguage={searchConditionAsNaturalLanguage}
    >
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>STT</TableCell>
          <TableCell>Ngày</TableCell>
          <TableCell>Số Phiếu</TableCell>
          <TableCell>Đơn đặt hàng</TableCell>
          <TableCell>Tên giao dịch</TableCell>
          <TableCell>Lệnh sản xuất</TableCell>
          <TableCell>Người đóng gói</TableCell>
          <TableCell>KCS Kiểm</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {packingNotes.map((x, i) => (
          <Row data-id={x.id} key={x.id} packingNote={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  packingNote: IPackingNote;
};
const Row = observer(({ packingNote }: RowProps) => {
  const {
    packingNoteManagement: { setProp },
  } = useStores();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const goDetailHandler = useCallback(
    (order: IPackingNote) => {
      navigate(`${order.id}`);
      setProp("packingNoteDetail", cloneDeep(order));
    },
    [navigate, setProp],
  );
  return (
    <Fragment>
      <TableRow hover>
        <TableCell sx={{ width: "30px" }}>
          <ExpandButton
            onClick={() => setOpen(!open)}
            open={open}
          ></ExpandButton>
        </TableCell>
        <TableCell>{packingNote.orderNumber || ""}</TableCell>
        <TableCell>{dateTimeDisplay(packingNote.date || "")}</TableCell>
        <TableCell>{packingNote.number || ""}</TableCell>
        <TableCell>{packingNote.purchaseOrder?.poNumber || ""}</TableCell>
        <TableCell>
          {packingNote.customer ? (
            <CustomerDealingAndActiveInfo
              customer={packingNote.customer}
            ></CustomerDealingAndActiveInfo>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell>
          {(packingNote.workOrderPO?.woNumber ??
            packingNote.workOrder?.woNumber) ||
            ""}
        </TableCell>
        <TableCell>{packingNote.kcsPackage || ""}</TableCell>
        <TableCell>{packingNote.kcsTest || ""}</TableCell>
        <TableCell width={"20px"}>
          <DetailIconButton
            onClick={() => goDetailHandler(packingNote)}
          ></DetailIconButton>
        </TableCell>
      </TableRow>
      {open && (
        <XSubRow>
          <XGroupCell colSpan={11} headerTitle="Chi tiết mặt hàng">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Tên hàng</TableCell>
                  <TableCell>Mã hàng</TableCell>
                  <TableCell>Mã vạch</TableCell>
                  <TableCell>ĐVT</TableCell>
                  <TableCell>Số lượng (pcs)</TableCell>
                  <TableCell>TL Tịnh (kg)</TableCell>
                  <TableCell>TL có bì (kg)</TableCell>
                  <TableCell>Hạn tái kiểm</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {packingNote.items.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>
                      {item.product ? (
                        <ProductNameAndActiveInfo
                          product={item.product}
                        ></ProductNameAndActiveInfo>
                      ) : (
                        ""
                      )}
                    </TableCell>
                    <TableCell>{item.product?.code || ""}</TableCell>
                    <TableCell>{item.product?.barcode || ""}</TableCell>
                    <TableCell>
                      {item.product?.unitOfCalculation || ""}
                    </TableCell>
                    <TableCell>
                      <NumberText value={item.amount}></NumberText>
                    </TableCell>

                    <TableCell>
                      <NumberText value={item.netWeight}></NumberText>
                    </TableCell>
                    <TableCell>
                      <NumberText value={item.grossWeight}></NumberText>
                    </TableCell>
                    <TableCell>{dateTimeDisplay(item.expiredDate)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </XGroupCell>
        </XSubRow>
      )}
    </Fragment>
  );
});
